import type { SettingSeoTemplate } from '../hooks/useSettingsSeo';
import { getSettingsSeoMetaExample } from './getSettingsSeoMetaExample';
import { getSettingsSeoMetaPlaceholder } from './getSettingsSeoMetaPlaceholder';

export function getSettingsSeoTemplateValue(
    seoTemplateFieldValue: string | undefined,
    seoTemplateSetting: SettingSeoTemplate,
    replacementValue?: string
) {
    if (seoTemplateFieldValue) {
        return seoTemplateFieldValue;
    }

    const template = seoTemplateSetting.value || getSettingsSeoMetaPlaceholder(seoTemplateSetting.path);

    return getSettingsSeoMetaExample(template, seoTemplateSetting.path, replacementValue);
}
